import { Injectable } from '@angular/core';
import { EnvService } from '../env.service';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class PurchaseService {
  apiUrl = '';
  constructor(private http: HttpClient,
              private envService: EnvService) {
        this.apiUrl = envService.API_URL;
   }

 buyPromotion(data) {
    const apiUrl = this.apiUrl + `purchase/promotion/${data.promotion_id}/charge`;
    return this.http.post(apiUrl, data, { withCredentials: true });
 }

 validatePromoCode(promocode, promotionId) {
    const apiUrl = this.apiUrl + `promocodes/${promocode}/${promotionId}/apply`;
    return this.http.get(apiUrl);
}

buyStudioTermPlan(venueid, data) {
  const apiUrl = this.apiUrl + 'purchase/spaces/' + venueid + '/charge';
  return this.http.post(apiUrl, data, { withCredentials: true });
}

//   $scope.validatePromocode = function() {
//     var promotionCode = $stateParams.code;
//     $scope.apiCallDone = false;
//     if (promotionCode) {
//       $http.get('https://jedi.promoga.com/api/promocodes/' + promotionCode + '/apply')
//         .success(function(data) {
//             $scope.apiCallDone = true;
//             if (data.status == true) {
//                 // if successful
//                 $scope.codeValid = true;
//                 $rootScope.promocode = data.result.code;
//                 $rootScope.promoAmt = data.result.amount;
//             } else {
//                 $scope.codeValid = false;
//                 $rootScope.promocode = '';
//                 $rootScope.promoAmt = '';
//                 if (data.status == false) {
//                     $scope.errorMsg = data.error.message;
//                 }
//             }
//         })
//         .error(function(data, status) {
//             $scope.apiCallDone = true;
//             $scope.codeValid = false;
//             $rootScope.promocode = '';
//             $rootScope.promoAmt = '';
//         })

//     } else {
//         $state.go('app.home');
//     }
// }
}
